import ImportResources from "./ImportResources";
import Buildings from "./Buildings";
import Flats from "./Flats";

export default {
    "apartments.resource-bindings": ImportResources,
    "apartments.buildings": Buildings,
    "apartments.flats": Flats,
};
